import { h } from "@zyra/dom";
import { createUI } from "./components.js";
export type {
  ButtonProps,
  CardProps,
  BadgeProps,
  InputProps,
  TextareaProps,
  SelectProps,
  DialogProps,
} from "./components.js";
export const { Button, Card, Badge, Input, Textarea, Select, Dialog } =
  createUI(h);
